import { replace, push } from 'connected-react-router'
import { INITIALIZE_APPLICATION } from '../constants/action.types'
import { history } from '../config/store'

export default ({ dispatch }) => next => action => {
  /*
    In order to detect if an user entered directly from URL,
    the first page flag is added to the history state.
  */
  if (action.type === INITIALIZE_APPLICATION) {
    const { mfa_enforced: isMfaEnforced } = action.payload.user || {}
    const firstPage = true
    const updatedLocation = { ...history.location, firstPage }

    if (isMfaEnforced) {
      dispatch(push(updatedLocation))
    } else {
      dispatch(replace(updatedLocation))
    }
  }

  return next(action)
}
